module.exports = __webpack_public_path__ + "img/clement-hero2-min.998455d7.png";